<lib-carousel
  *ngIf="businessObjects?.length"
  [autoplay]="true"
  [interval]="2000"
  [loop]="true"
  [hideArrows]="true"
  [hideIndicators]="businessObjects.length / slidePerView > 5"
  [useKeyboard]="false"
  [useMouseWheel]="false"
  [orientation]="'LEFT_TO_RIGHT'"
  [maintainAspectRatio]="false"
  [slidesPerView]="slidePerView"
>
  <lib-carousel-slide *ngFor="let salon of businessObjects">
    <app-salon-card
      [salonName]="salon.name"
      [salonAddress]="salon.address"
      [salonCurrency]="salon.currency"
      [image]="getSalonPicture(salon)"
      [id]="salon?.placeId"
      [discountProducts]="getDiscountProducts(salon)"
      (imageClicked)="navigateToSalonDetails(salon)"
      (bodyClicked)="navigateToSalonDetails(salon)"
    >
      <div body class="description">
        <app-rating-star-icon
          *ngIf="salon.googlePlace?.user_ratings_total"
          [rating]="salon.googlePlace.rating"
          [totalReview]="salon.googlePlace.user_ratings_total"
        ></app-rating-star-icon>
        <div>{{ salon.telephone }}</div>
      </div>

      <div footer fxLayout="row" fxLayoutAlign="end center">
        <button
          mat-raised-button
          color="primary"
          (click)="navigateToSalonDetails(salon)"
        >
          {{ 'salon-search-result-page.buttons.book-appointment' | translate }}
        </button>
      </div>
    </app-salon-card>
  </lib-carousel-slide>
</lib-carousel>

<lib-spacer></lib-spacer>
